import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentListComponent } from './document-list/document-list.component';
import { DocumentsDataModule } from '@fleetoperate/shared/documents/data-access-documents';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToastModule } from '@fleetoperate/shared/util';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
  declarations: [DocumentListComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    DocumentsDataModule,
    ToastModule
  ],
  exports: [DocumentListComponent]
})
export class ShipmentDocumentsModule { }
